import React from 'react';

import styles from './AccessToCommunity.module.css';

export default ({
  internalRecord,
  setInternalRecord
  // activePopup
}) => (
  <div className={styles.content}>
    <div className={styles.row}>
      <div className={styles.label}>Incidence rate (in %)</div>
      <div className={styles.inputContainer}>
        <input
          className={styles.valueInput}
          placeholder="0"
          value={
            internalRecord.permissions.incidenceRateIncludedInLicence || ''
          }
          onChange={e => {
            let newAllocatedValue = 0;
            if (e.target.value && e.target.value !== '') {
              newAllocatedValue = parseInt(e.target.value, 10);
            }

            setInternalRecord({
              ...internalRecord,
              permissions: {
                ...internalRecord.permissions,
                incidenceRateIncludedInLicence: newAllocatedValue
              }
            });
          }}
          onKeyDown={evt =>
            evt.key === 'ArrowDown' ||
            evt.key === 'ArrowUp' ||
            evt.key === 'e' ||
            evt.key === 'E' ||
            evt.key === '-'
              ? evt.preventDefault()
              : null
          }
          onWheel={e => e.target.blur()}
          maxLength="6"
          type="number"
          spellCheck
        />
      </div>
    </div>
    <div className={styles.row}>
      <div className={styles.label}>Default sample size</div>
      <div className={styles.inputContainer}>
        <input
          className={styles.valueInput}
          placeholder="0"
          value={internalRecord.permissions.sampleSizeIncludedInLicence || ''}
          onChange={e => {
            let newAllocatedValue = 0;
            if (e.target.value && e.target.value !== '') {
              newAllocatedValue = parseInt(e.target.value, 10);
            }

            setInternalRecord({
              ...internalRecord,
              permissions: {
                ...internalRecord.permissions,
                sampleSizeIncludedInLicence: newAllocatedValue
              }
            });
          }}
          onKeyDown={evt =>
            evt.key === 'ArrowDown' ||
            evt.key === 'ArrowUp' ||
            evt.key === 'e' ||
            evt.key === 'E' ||
            evt.key === '-'
              ? evt.preventDefault()
              : null
          }
          onWheel={e => e.target.blur()}
          maxLength="6"
          type="number"
          spellCheck
        />
      </div>
    </div>
    <div className={styles.row}>
      <div className={styles.label}>
        Number of survey questions included in license
      </div>
      <div className={styles.inputContainer}>
        <input
          className={styles.valueInput}
          placeholder="0"
          value={
            internalRecord.permissions.questionsPerSurveyIncludedInLicence || ''
          }
          onChange={e => {
            let newAllocatedValue = 0;
            if (e.target.value && e.target.value !== '') {
              newAllocatedValue = parseInt(e.target.value, 10);
            }

            setInternalRecord({
              ...internalRecord,
              permissions: {
                ...internalRecord.permissions,
                questionsPerSurveyIncludedInLicence: newAllocatedValue
              }
            });
          }}
          onKeyDown={evt =>
            evt.key === 'ArrowDown' ||
            evt.key === 'ArrowUp' ||
            evt.key === 'e' ||
            evt.key === 'E' ||
            evt.key === '-'
              ? evt.preventDefault()
              : null
          }
          onWheel={e => e.target.blur()}
          maxLength="6"
          type="number"
          spellCheck
        />
      </div>
    </div>
  </div>
);
